<template>
  <div class="invitation-dialog-">
    <!-- 生成邀请链接 -->
    <el-dialog title="温馨提示" :visible.sync="inviteModal" width="640px" :before-close="close">
      <div style="padding: 24px; text-align: center;">
        <div style="text-align: center;"><img src="https://uifox-public.oss-cn-hangzhou.aliyuncs.com/common/market_v2/login/leftImgWx.png" width="280" height="120" /></div>
        <div class="dialog-text">Hi，{{inviteinfo ? inviteinfo.companyCNName : ''}} 邀请您加入企业！</div>
        <div class="dialog-desc">注：加入企业后您个人账户的资金（例如充值票）将并入企业账户且不可回退</div>
        <el-button class="dialog-btn" type="primary" @click="joinCompany">同意加入</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { httpAjax } from "@/api/ajax"
import { mapActions } from "vuex"

export default {
  name: 'InvitationDialog',
  props: {
    inviteCode: Number | String,
    inviteModal: {
      type: Boolean,
      default: false
    },
    inviteinfo: {
      type: Object,
      default: () => { }
    }
  },
  data () {
    return {
    }
  },
  created () {

  },
  methods: {
    ...mapActions(['user/getUserData']),
    // close
    close () {
      this.$emit('close')
    },
    // 加入企业
    joinCompany () {
      httpAjax({
        url: `/services/company/invite/${this.inviteCode}/confirm`,
        method: "post",
      }).then((response) => {
        if (response.success) {
          this.$message({
            message: '您已成功加入 ' + this.inviteinfo.companyCNName,
            type: 'success'
          })
          this['user/getUserData']()
          this.close()
          // setTimeout(() => {
          //   location.href="/";
          // }, 500);
        } else {
          this.$message({
            message: response.msg,
            type: 'error'
          })
        }
      })
    },
  },
}
</script>

<style scoped lang='less'>
.dialog-text {
  // height: 28px;
  font-size: 24px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #333333;
  line-height: 28px;
  margin: 32px 0 16px 0;
}
.dialog-desc {
  height: 22px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
  line-height: 22px;
  margin-bottom: 32px;
}
.dialog-btn {
  width: 260px;
  height: 32px;
  background: #1677ff;
  border-radius: 4px;
  line-height: 0px !important;
}
</style>
